// Acces "energie illimitee" pour Reps.
// Trois abonnements donnent l'illimite : Premium (pro), Ultra (ultimate, badge
// "Founder") et Essential (l'offre dediee Reps), plus l'acces OFFERT pose depuis
// la fiche admin (repsUnlimitedGranted). Etre admin ne donne PLUS l'illimite de
// droit : un admin sans flag ni abonnement vit les cles reelles (le
// deverrouillage du contenu pour relecture, lui, reste). Formule unique et
// reutilisable, cf. docs/reps/REPS_TECHNICAL_PLAN.md ; miroir back :
// RepsKeyService::isUnlimited.
export function hasUnlimitedEnergy(user) {
    if (!user) return false;
    // Accès offert : jamais gelé, il ne dépend d'aucun prélèvement.
    if (user.repsUnlimitedGranted) return true;
    // Grâce de paiement : l'abonné garde le contenu mais retombe sur le quota
    // gratuit tant que sa facture est impayée. Miroir de
    // RepsKeyService::isUnlimited, qui reste seul juge.
    if (user.paymentPastDue) return false;
    return Boolean(user.pro || user.ultimate || user.essential);
}

// Quota gratuit, en clés par jour (1 clé = 1 leçon). Sert à l'annoncer sur la
// page de présentation, où il n'y a ni compte ni état de clés à interroger.
// MIROIR de RepsKeyService::KEYS_PER_DAY : le back reste seul juge, ce nombre
// n'est ici que pour l'écrire. Les deux doivent bouger ensemble.
export const REPS_FREE_KEYS_PER_DAY = 3;

// Chat BeBot dans le player Reps : palier minimal requis.
// "plus"    -> Believemy Plus (essential) ET Believemy Pro (pro) / Ultra.
// "premium" -> UNIQUEMENT Believemy Pro (pro) / Ultra.
// Un seul mot a changer pour restreindre l'acces ; la route API et l'UI
// (paywall compris) suivent automatiquement.
export const REPS_ASSISTANT_TIER = "plus";

/** Le chat BeBot fait-il partie de l'offre Plus ? Pilote ce que /pricing annonce. */
export function repsAssistantIncludedInPlus() {
    return REPS_ASSISTANT_TIER === "plus";
}

export function hasRepsAssistant(user) {
    if (!user) return false;
    // L'acces OFFERT (repsUnlimitedGranted) debloque aussi le chat : un compte
    // auquel on offre Reps doit vivre l'experience complete, BeBot compris.
    if (user.pro || user.ultimate || user.repsUnlimitedGranted) return true;
    return REPS_ASSISTANT_TIER === "plus" && Boolean(user.essential);
}

// Saut d'unite : passer le test de l'unite courante pour la valider d'un coup.
// Avantage ABONNE (decision produit : le gratuit fait tout le chemin, le saut
// se paie ET se merite — le test reste obligatoire pour tout le monde).
// Meme perimetre que l'energie illimitee aujourd'hui ; fonction dediee pour
// pouvoir dissocier les paliers demain sans retoucher les composants.
// Miroir back : le verrou reel est RepsKeyService::isUnlimited dans
// unitSkipStart/unitSkipSubmit — ceci ne pilote que l'UI.
export function hasUnitSkip(user) {
    return hasUnlimitedEnergy(user);
}
